<template ref="search">
    <InputLayout :v="v" :label="label">
        <div class="dropdown-input-container" :class="{ 'is-invalid': v && v.$error, 'input-group': !searchable}">
            <div v-if="prependIcon" class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"><i class="bi" :class="prependIcon"></i></span>
            </div>
            
            <!-- Searchable input -->
            <div class="dropdown" :class="{ 'show': showDropdown }">
                <template v-if="searchable">
                    <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': v && v.$error }"
                        :id="v.$path"
                        :value="searchText"
                        @input="onSearchInput"
                        @blur="onBlur"
                        autocomplete="off"
                        placeholder="Type to search..."
                        ref="searchInput"
                        @click="onFocus"
                    />

                    <!-- Clear button shown after selection -->
                    <button
                        v-if="modelValue"
                        type="button"
                        class="clear-btn"
                        @click.stop="reset"
                        aria-label="Clear selection"
                    >&times;</button>
                </template>

                <template v-else>
                    <!-- Regular select for non-searchable -->
                    <select
                        class="form-select" 
                        :id="v.$path" 
                        :class="{ 'is-invalid': v && v.$error }" 
                        :value="modelValue" 
                        @input="$emit('update:modelValue', $event.target.value)"
                    >
                        <option v-if="!removeEmptyOption" :disabled="disableFirstOption"></option>
                        <option v-for="option of options" v-bind:key="option.id" :value="option.id" :disabled="option.enabled !== undefined && option.enabled != true">{{option.label}}</option>
                    </select>
                </template>

                <!-- Dropdown menu for searchable -->
                <ul v-if="searchable" class="dropdown-menu" :class="{ 'show': showDropdown }">
                    <li v-if="filteredOptions.length === 0" class="dropdown-item disabled">No results found</li>
                    <li v-for="option in filteredOptions" :key="option.id">
                        <a 
                            class="dropdown-item" 
                            href="#" 
                            @click.prevent="selectOption(option)"
                            :class="{ 'disabled': option.enabled !== undefined && option.enabled != true }"
                        >
                            {{ option.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </InputLayout>
</template>

<script>
    import InputLayout from '@/components/InputLayout.vue';

    export default {
        props: {
            label: {
                required: true
            },
            v: {
                required: true,
            },
            modelValue: {
                required: true,
            },
            options: {
                required: true,
            },
            removeEmptyOption: {
              default: false
            },
            prependIcon: {
              default: false
            },
            disableFirstOption: {
              default: false
            },
            searchable: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                searchText: '',
                showDropdown: false,
                selectedOption: null,
            }
        },
        computed: {
            filteredOptions() {
                if (!this.searchable || !this.searchText.trim()) {
                    return this.options;
                }
                return this.options.filter(option => 
                    option.label.toLowerCase().includes(this.searchText.toLowerCase())
                );
            },
            selectedLabel() {
                if (!this.modelValue) return '';
                const option = this.options.find(opt => opt.id == this.modelValue);
                return option ? option.label : '';
            }
        },
        watch: {
            modelValue: {
                immediate: true,
                handler(newVal) {
                    if (this.searchable && newVal) {
                        const option = this.options.find(opt => opt.id == newVal);
                        this.searchText = option ? option.label : '';
                    }
                }
            }
        },
        components: {            
            InputLayout,
        },
        emits: ['update:modelValue'],
        methods: {
            onSearchInput(event) {
                this.searchText = event.target.value;
                this.showDropdown = true;
            },
            onFocus() {
                this.showDropdown = true;
            },
            onBlur() {
                // Delay hiding to allow click on dropdown items
                setTimeout(() => {
                    this.showDropdown = false;
                }, 200);
            },
            selectOption(option) {
                this.$emit('update:modelValue', option.id);
                this.searchText = option.label;
                this.showDropdown = false;
            },
            reset() {
                this.searchText = '';
                this.$emit('update:modelValue', '');
            }
        }
    }
</script>

<style scoped>
.dropdown-input-container {
    position: relative;
}

.dropdown-input-container.input-group > .dropdown {
    flex: 1 1 auto;
    width: 1%;
}

.dropdown-input-container.input-group > .dropdown > .form-select {
    width: 100%;
}

.dropdown-input-container .form-control,
.dropdown-input-container .form-select {
    padding-right: 2.5rem;
}

.clear-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    font-size: 1.2rem;
    line-height: 1;
    padding: 0 6px;
    color: #6c757d;
    cursor: pointer;
}

.clear-btn:hover {
    color: #000;
}

.dropdown-menu {
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}

.dropdown-item.disabled {
    color: #6c757d;
    pointer-events: none;
}
</style>
